import useSelectedPharmacy from 'app/hooks/useSelectedPharmacy';
import { useOrganisationFeaturesOf } from 'app/hooks/useOrganisationFeatures';

export interface PlusUpgradeRequestStatus {
  requested: boolean;
  /** Not known yet whether the organisation has asked, so it is not offered the request. */
  isLoading: boolean;
}

// Whether the organisation has already asked account management for Plus. Defaults to the selected
// pharmacy's organisation, the same one the Request Plus journey asks for.
export default function usePlusUpgradeRequested(organisationId?: string): PlusUpgradeRequestStatus {
  const selectedPharmacy = useSelectedPharmacy();
  const { plusUpgradeRequested, isLoading } = useOrganisationFeaturesOf(
    organisationId ?? selectedPharmacy?.chain_id
  );

  return { requested: plusUpgradeRequested, isLoading };
}
